export enum ResourceType {
  VEHICLE = 'VEHICLE',
  TECHNICIAN = 'TECHNICIAN',
  PROJECT = 'PROJECT',
}
